
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Toast from 'vux/src/components/toast/index.vue'

import {Dialog} from "vant";
export default {
name: "",
props: [""],
data() {
return {
urls: this.$route.params.data,
getData: {},
apiurl: "",
loading: false,
myUrl: "",
num: 100,
price: 0
};
},
directives: {
TransferDom,
},
components: { Loading, Toast },

computed: {},

beforeMount() {},

mounted() {
this.loginType = localStorage.getItem("login_type");
this.$http.get("./static/api/api.json").then((response) => {
this.apiurl = response.api;
this.myUrl = location.href.split("#")[0];
this.getPriceConfig();
});
},

methods: {
getPriceConfig() {
this.loading = true;
this.$http.get(this.apiurl + "/web/priceConfig/1").then((res) => {
if (res.code === 0) {
this.getData = res.data;
this.numChange()
}
this.loading = false;
});
},
numChange(){
this.price = this.getData.price * this.num * 100
},
buy(id){
Dialog.confirm({
title: '购买',
message: '确定立即购买吗？',
})
.then(() => {

let _this = this;
const postData = {
typeId: id,
nums: this.num
};
_this.$http
.post(_this.apiurl + "/web/order/create", postData)
.then((res) => {
if (res.code === 0) {
wx.chooseWXPay({
timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
package: res.data.packageValue, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
signType: res.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
paySign: res.data.paySign, // 支付签名
success: function (res) {

_this.$vux.toast.text("支付成功", "top");
_this.$router.push({
path: "/wallet",
});
},
});
} else {
_this.$vux.toast.text(res.msg, "top");
}
});
})
.catch(() => {

});
}
},

watch: {},
};



// WEBPACK FOOTER //
// ./src/components/recharge.vue